import type { CampaignJournal } from '@danda/shared';

export const journalSlice = {
  lobbyJournal: null as CampaignJournal | null,
  lobbyJournalLoading: false,
  lobbyJournalFetched: false,

  setLobbyJournal: (journal: CampaignJournal | null) => ({ lobbyJournal: journal }),
  setLobbyJournalLoading: (loading: boolean) => ({ lobbyJournalLoading: loading }),
  setLobbyJournalFetched: (fetched: boolean) => ({ lobbyJournalFetched: fetched }),

  clearLobbyJournal: () => ({
    lobbyJournal: null as CampaignJournal | null,
    lobbyJournalLoading: false,
    lobbyJournalFetched: false,
  }),
};
